// A product's units as the purchasing lines use them (`productUOMs` with their `uom`).

export interface ProductUnit {
  id: string;
  name: string;
  /** The product unit's conversion factor. */
  factor: number;
  isBase: boolean;
}

const positive = (value: unknown): number | null => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const unitsOfProduct = (product: any): ProductUnit[] =>
  (product?.productUOMs ?? [])
    .filter((unit: any) => unit?.id)
    .map((unit: any) => ({ id: String(unit.id), name: String(unit?.uom?.uomName ?? ''), factor: positive(unit?.conversionFactor) ?? 1, isBase: !!unit?.isBase }));

/** The base unit, else the first unit. */
export const defaultUnitId = (units: ProductUnit[]): string => (units.find((unit) => unit.isBase) ?? units[0])?.id ?? '';

export const factorOf = (units: ProductUnit[], unitId: string): number => units.find((unit) => unit.id === unitId)?.factor ?? 1;
